import { get, post, put, del } from './apiService';

/**
 * Get products with pagination and filters
 * @param {number} page - Page number
 * @param {number} size - Page size
 * @param {string} nameFilter - Product name filter
 * @param {string} product_id - Product ID filter
 * @returns {Promise<object>} Products data with screens
 */
export async function getProducts(page = 1, size = 10, nameFilter, product_id) {
  const queryParams = new URLSearchParams({
    page: page.toString(),
    size: size.toString(),
  });

  if (nameFilter && nameFilter.trim() !== '') {
    queryParams.append('product_name', nameFilter.trim());
  }
  if (product_id && product_id.trim() !== '') {
    queryParams.append('product_id', product_id.trim());
  }

  return await get(`/screen/products?${queryParams.toString()}`);
}



/**
 * Update product screen association
 * @param {string} productId - Product ID
 * @param {string} screenId - Screen ID
 * @param {boolean} isActive - Whether to activate or deactivate
 * @returns {Promise<object>} Response
 */
export async function updateProductScreen(productId, screenId, isActive) {
  const payload = {
    screen_id: screenId,
    product_id: productId,
    is_active: true,
  };

  if (isActive === true) {
    return await post('/screen/products', payload);
  } else {
    return await del('/screen/products', payload);
  }
}

/**
 * Filter products by ID
 * @param {string} product_id - Product ID
 * @param {string} product_name - Product name (not used currently)
 * @returns {Promise<object>} Filtered products
 */
export async function filterProducts(product_id, product_name) {
  const queryParams = new URLSearchParams();
  if (product_id) queryParams.append('product_id', product_id);

  return await get(`/screen/products?${queryParams.toString()}`);
}

/**
 * Get tech card details for a product
 * @param {string} product_id - Product ID
 * @returns {Promise<object>} Product details with modifiers and tech cards
 */
export async function getTexCard(product_id) {
  const queryParams = new URLSearchParams();
  if (product_id) queryParams.append('product_id', product_id);

  return await get(`/screen/product/content?${queryParams.toString()}`);
}

/**
 * Update product timer
 * @param {string} product_id - Product ID
 * @param {string} timer - Timer value (HH:MM:SS format)
 * @returns {Promise<object>} Updated product
 */
export async function updateTimer(product_id, timer) {
  return await put('/products', {
    id: product_id,
    timer: timer,
  });
}
